import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/niveles-salariales-tabulares';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: true,
  });
  return [formattedValues, config];
};

/**
 * GET Niveles Salariales Tabulares
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getNivelesSalarialesTabulares = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Nivel Salarial Tabular
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getNivelSalarialTabular = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Nivel Salarial Tabular
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postNivelSalarialTabular = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Nivel Salarial Tabular
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchNivelSalarialTabular = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Nivel Salarial Tabular
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteNivelSalarialTabular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
